import { defineComponent, h, onMounted } from 'vue';
import { LegacyNegativeAnswerItem } from '@/ui/components/inspectionReport/legacyTypes';
import { t } from '@/ui/i18n/i18n';
import { makeQuestion } from '@/ui/components/inspectionReport/items/Question';
import { useCurrentRoute } from '@/ui/routes';
import { InspectionDetailSections } from '@/ui/routes/types';
import { scrollToElementById } from '@/ui/helpers/';

interface NegativeAnswersProps {
  items: Array<LegacyNegativeAnswerItem>;
}

export const NegativeAnswers = defineComponent<NegativeAnswersProps>({
  name: 'NegativeAnswers',
  props: {
    items: {
      default: () => [],
    },
  },
  setup(props) {
    const currentRoute = useCurrentRoute();

    onMounted(() => {
      const { section } = currentRoute.value.params;
      if (section) {
        scrollToElementById(section);
      }
    });

    return function render() {
      if (!props.items.length) {
        return null;
      }

      const title = `${t('inspection-report.negative-answers')} (${props.items.length})`;

      return h('div', {
        class: 'mb-4 inspection-report__negative-answers',
        attrs: {
          id: InspectionDetailSections.NEGATIVE_ANSWERS,
        },
      }, [
        h('span', { class: 'inspection-report__general-title font-semibold' }, title),
        h('table', { class: 'inspection-report__table mt-2' }, [
          ...props.items.map(item => makeQuestion(item, false)),
        ]),
      ]);
    };
  },
});
